import React from "react";


function About() {
    return (
        <div>
            <h6 className="about">About</h6>
            <p className="about-info">I am a frontend developer with a particular interest in making things simple and automating daily tasks. I try to keep up with security and best practices, and am always looking for new things to learn.</p>
        </div>
)
}

export default About;